import line from "../images/Line1.svg";
import profile from "../images/profile.jpg";
import html from "../images/html.png";
import css from "../images/css.png";
import js from "../images/js.png";
import reactjs from "../images/react.png";
import laravel from "../images/laravel.png";
import php from "../images/php.png";
import mysql from "../images/mysql.png";
import figma from "../images/figma.png";
import photoshop from "../images/photoshop.png";
import illustrator from "../images/illustrator.png";
import boostrap from "../images/bootstrap.png";
import tailwind from "../images/tailwind.png";

const AboutMe = () => {
  return (
    <div className="mt-64 px-4 md:mt-10 md:px-12" id="aboutme">
      <div className="flex">
        <img src={line} alt="" />
        <p>&emsp; Let's get started</p>
      </div>
      <div className="mt-12 grid gap-48 w-full md:px-24 md:grid-cols-2">
        <div>
          {" "}
          <h2 className="text-4xl uppercase font-semibold">about me</h2>
          <img
            src={profile}
            className="rounded-[50%] block w-[30%] my-10 mx-auto md:hidden"
            alt=""
          />
          <p className="mt-6">
            My name is Kevin. I already have interest about computers ever since
            when I was a kid. I remember the first time I held a mouse and a
            keyboard and play video games on my aunt's computer. I realized
            there's so much more about computer that's why I took a degree in
            Computer Engineering in college.
          </p>
          <p className="my-6">
            After I graduated, I didn't knew about the world of Web Development
            that's why I dedicate and commit myself to teach and practice it
            myself - providing relevant and creative solutions and problem
            solver. Until I took it in a serious level and decided to enroll in
            a bootcamp. I learned so much and now I am ready to turn my passion
            into a promising career.
          </p>
          <h2 className="text-4xl uppercase font-semibold mt-24 md:mt-48">
            skills
          </h2>
          <div className="mt-10 grid grid-cols-4 gap-3">
            <img className="w-[100%]" src={html} alt="" />
            <img className="w-[100%]" src={css} alt="" />
            <img className="w-[100%]" src={boostrap} alt="" />
            <img className="w-[100%]" src={tailwind} alt="" />
            <img className="w-[100%]" src={js} alt="" />
            <img className="w-[100%]" src={reactjs} alt="" />
            <img className="w-[100%]" src={laravel} alt="" />
            <img className="w-[100%]" src={php} alt="" />
            <img className="w-[100%]" src={mysql} alt="" />
            <img className="w-[100%]" src={photoshop} alt="" />
            <img className="w-[100%]" src={illustrator} alt="" />
            <img className="w-[100%]" src={figma} alt="" />
          </div>
        </div>
        <img
          src={profile}
          className="hidden md:block md:w-[75%] rounded-[50%]"
          alt=""
        />
      </div>
    </div>
  );
};

export default AboutMe;
